import React from 'react';
import PropTypes from 'prop-types';
import rapportPackage from './rapport-web.json';
import { withTranslation } from '@ifit/rapport-webview';
import I18nType from '../../../shared/i18n-prop-type';

const WorkoutNumber = ({ i18n, programInfo }) => (
  <span className="workout-number">
    {i18n._translate(
      '%{currentWorkoutIndex} of %{seriesWorkoutTotal} complete',
      {
        currentWorkoutIndex: programInfo.currentWorkoutIndex + 1,
        seriesWorkoutTotal: programInfo.total,
      }
    )}
  </span>
);

WorkoutNumber.propTypes = {
  programInfo: PropTypes.shape({
    total: PropTypes.number,
    currentWorkoutIndex: PropTypes.number,
  }),
  i18n: I18nType,
};

WorkoutNumber.defaultProps = {
  workoutCount: 0,
};

export default withTranslation(rapportPackage)(WorkoutNumber);
